import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import stringEN from './assets/translate/language/en/string_en.json';
import stringDE from './assets/translate/language/de/string_de.json';
import stringES from './assets/translate/language/es/string_es.json';
import stringFR from './assets/translate/language/fr/string_fr.json';
import stringIT from './assets/translate/language/it/string_it.json';
import stringKO from './assets/translate/language/ko/string_ko.json';
import stringPL from './assets/translate/language/pl/string_pl.json';
import stringRU from './assets/translate/language/ru/string_ru.json';
import stringTR from './assets/translate/language/tr/string_tr.json';


i18next
    .use(LanguageDetector) // 1. Подключаем детектор языка
    .use(initReactI18next) // 2. Подключаем React-биндинги
    .init({
        fallbackLng: 'en', // Язык по умолчанию, если язык пользователя не найден

        // Настройки интерполяции
        interpolation: {
            escapeValue: false, // React уже защищает от XSS, экранирование не нужно
        },

        // Ресурсы переводов
        resources: {
            en: { translation: stringEN },
            de: { translation: stringDE },
            es: { translation: stringES },
            fr: { translation: stringFR },
            it: { translation: stringIT },
            ko: { translation: stringKO },
            pl: { translation: stringPL },
            ru: { translation: stringRU },
            tr: { translation: stringTR },

            // Пример для будущего английского языка:
            // en: { translation: stringEN },
        },

        // Опции детектора (порядок проверки языка)
        detection: {
            order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage', 'cookie'], // Где запоминать выбор языка
        }
    });

export default i18next;